<div #mapElement class="cx-store-map"></div>
